<template>
  <div :style="outerStyles" class="logo">
      <v-img :src="require('@/_static/img/background/logo1.png')" contain></v-img>
  </div>

</template>

<script>
import userSettings from "@/_mixins/user-settings-mixin"
export default {
  name: 'DialogScrollable',
  components: {},
  mixins : [userSettings],
  props : {
  },
  computed : {
    outerStyles()
    {
      var ret = {};
      ret["background-color"] = this.globalDarkMode ? "rgba(0,0,0,.5)" : "rgba(255,255,255,.6)";
      return ret;
    }
  },
  data()
  {
    return {

    }
  },
  methods : {
  }
}
</script>

<style scoped lang="scss">
.logo
{
  display:flex;
  padding:5px 15px;
  border-radius:5px;
  width:100%;
}
.logo > *
{
  width:100%;
}
</style>
